import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";

const AddUser = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    phone_number: "",
    password: "",
    password_confirm: "",
    role: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    organization: "",
    address_line_1: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    try {
      await apiClient.post("/auth/users/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // alert("User created successfully");
      navigate("/users");
    } catch (err) {
      console.error(err);
      // alert("Failed to create user");
    }
  };

  return (
    <div className="form-container">
      <h2>New User Creation</h2>
      <form onSubmit={handleSubmit} className="user-form">
        {/* email */}
        <label>Email *</label>
        <input type="email" name="email" value={form.email} onChange={handleChange} required />

        <label>Phone Number</label>
        <input type="text" name="phone_number" value={form.phone_number} onChange={handleChange} />

        <label>Password *</label>
        <input type="password" name="password" value={form.password} onChange={handleChange} required />

        <label>Confirm Password *</label>
        <input
          type="password"
          name="password_confirm"
          value={form.password_confirm}
          onChange={handleChange}
          required
        />

        <label>Role *</label>
        <select name="role" value={form.role} onChange={handleChange} required>
          <option value="">Select Role</option>
          <option value="admin">Admin</option>
          <option value="client_admin">Client Admin</option>
          <option value="project_admin">Project Admin</option>
          <option value="surveyor">Surveyor</option>
        </select>

        <label>First Name *</label>
        <input type="text" name="first_name" value={form.first_name} onChange={handleChange} required />

        <label>Middle Name</label>
        <input type="text" name="middle_name" value={form.middle_name} onChange={handleChange} />

        <label>Last Name *</label>
        <input type="text" name="last_name" value={form.last_name} onChange={handleChange} required />

        <label>Organization</label>
        <input type="text" name="organization" value={form.organization} onChange={handleChange} />

        <label>Address Line 1 *</label>
        <input type="text" name="address_line_1" value={form.address_line_1} onChange={handleChange} required />

        <label>City *</label>
        <input type="text" name="city" value={form.city} onChange={handleChange} required />

        <label>State *</label>
        <input type="text" name="state" value={form.state} onChange={handleChange} required />

        <label>Country *</label>
        <input type="text" name="country" value={form.country} onChange={handleChange} required />

        <label>Postal Code *</label>
        <input type="text" name="postal_code" value={form.postal_code} onChange={handleChange} required />

        <button type="submit">Create User</button>
        <button type="button" onClick={() => navigate("/users")}>Cancel</button>
      </form>
    </div>
  );
};

export default AddUser;
